<ion-text>
  <p class="font-text">
    Os documentos necessários para que se inicie oficialmente o processo de regularização fundiária na prefeitura estão sendo elaborados e logo serão protocolados.
  </p>
</ion-text>
